<template>
  <div>
    <el-container>
      <el-header style="background-color: #0f58f5;">
        <hearder :isHome="false"> </hearder>
      </el-header>

      <el-container style="">
        <el-aside width="70px" class="a">
          <Lefter />
        </el-aside>
        <el-aside v-show="leftShow" width="480px" style="z-index: 1;">
          <!--          <component :is="componentName"></component>-->
          <LeftContent></LeftContent>
          <div class="close_left" @click="openLeftMain">
            <a href="javascript:;"
              ><img src="../../src/assets/image/wyc/close_ico.png"
            /></a>
          </div>
        </el-aside>

        <div
          style="margin: 0 auto;max-width: 840px;min-width: 500px;width: 95%;padding: 20px;"
        >
          <Editor
            v-show="editorShow"
            :contentHeight="contentHeight"
            ref="editors"
          />
          <WycContent v-show="wycShow"></WycContent>
          <!--            <WycListBtn class="listbutton"></WycListBtn>-->
          <div class="open_left" @click="openLeftMain">
            <a href="javascript:;"
              ><img src="../../src/assets/image/wyc/open_ico.png"
            /></a>
          </div>
        </div>

        <el-aside v-if="rightShow" width="480px" class="rContent a"
          ><RightContent :contentHeight="contentHeight"></RightContent
        ></el-aside>
      </el-container>
          <el-footer style="background:#f5f8ff;height:60px;position: fixed;
    bottom: 0;width:100%;z-index: 1000;">
         <div style="text-align: center;color:black!important;font-size: 14px;" v-if='dataSource && dataSource.length>0'>
<div class="links" >
      友情链接：
      <a v-for='(item,index) in dataSource' :key="index" :href="item.url" target="_blank" class="link-item">{{item.title}}</a>
    </div>

        </div>
          <div style="text-align: center;color:black!important;font-size: 14px;margin-bottom:10px;"><a style="color:black!important" target="_blank" href="https://beian.miit.gov.cn/ ">粤ICP备15002054号</a>  珠海市五一一八科技有限公司 </div>
      </el-footer>
    </el-container>
    <showLogin
      v-if="showLoginDialogs"
      :show-login-dialogs="showLoginDialogs"
      :show-message="showMessage"
      :show-btn="showBtn"
      @closeShowDialogs="closeShowDialogs"
    ></showLogin>
    <show-prompt
      v-if="showPrompt"
      :show-show-prompt="showPrompt"
      :show-message="showMessage"
      @closeShowPrompt="closeShowPrompt"
    >
    </show-prompt>
    <showUpgrade
      v-if="showUpgrade"
      @closeUpgrade="closeUpgrade"
      :show-message="showUpgradeMessage"
    ></showUpgrade>
    <showGift
      v-if="showGift || !useGift"
      @closeShowGift="closeShowGift"
      :show-type="useGift"
    ></showGift>
    <messageBox
      v-if="showMessageBox"
      :show-message-box="showMessageBox"
      :show-message="showMessage"
      :show-title="showTitle"
      :show-btn="showBtn"
      @closeShowMessageBox="closeShowMessageBox"
    ></messageBox>
    <wycShowBox
      :show-message-box="iswycShowMsg"
      @closeShowMessageBox="closeShowMessageBox"
    ></wycShowBox>
  </div>
</template>

<script>
// import Header from "../components/share/Header";
import Lefter from "../components/share/Left";
import Editor from "../components/share/Editor";
import LeftContent from "./LeftContent";
import wycShowBox from "../components/dialogs/wycShowBox";
// import SucaiSearch from "../views/Sucai/SucaiSearch";
import RightContent from "../views/RightContent";
import { mapState, mapMutations,mapActions } from "vuex";
// import WycListBtn from "../components/edit/WycListBtn";
import WycContent from "../components/edit/WycContent";
import hearder from "../components/share/Header";
import showUpgrade from "../components/dialogs/showUpgrade";
import messageBox from "../components/dialogs/messageBox";
import showGift from "../components/dialogs/showGift";
export default {
  components: {
    hearder,
    Lefter,
    Editor,
    // SucaiSearch,
    RightContent,
    WycContent,
    // WycListBtn,
    LeftContent,
    showUpgrade,
    messageBox,
    showGift,
    wycShowBox
  },
  data() {
    return {
      componentName: "SucaiSearch",
      scrollNum: 0,
      dataSource:[]
    };
  },
  watch: {
    leftShow: {
      handler(val) {
        if (val) {
          if (this.contentWidth < 1860) {
            this.rightShow = false;
          }
        }
      }
    },
    rightShow: {
      handler(val) {
        if (val) {
          if (this.contentWidth < 1860) {
            this.leftShow = false;
          }
        }
      }
    }
  },
  computed: {
    ...mapState("contents", [
      "showLoginDialogs",
      "showMessage",
      "showBtn",
      "showPrompt",
      "showUpgrade",
      "showUpgradeMessage",
      "showTitle",
      "showMessageBox",
      "showGift",
      "useGift",
      "iswycShowMsg"
    ]),
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    contentWidth: {
      get() {
        return this.$store.state.contents.contentWidth;
      },
      set(val) {
        this.$store.state.contents.contentWidth = val;
      }
    },
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    },
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    hotShow: {
      get() {
        return this.$store.state.contents.hotShow;
      },
      set(val) {
        this.$store.state.contents.hotShow = val;
      }
    },
    scShow: {
      get() {
        return this.$store.state.contents.scShow;
      },
      set(val) {
        this.$store.state.contents.scShow = val;
      }
    },
    editorShow: {
      get() {
        return this.$store.state.contents.editorShow;
      },
      set(val) {
        this.$store.state.contents.editorShow = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    wycContent: {
      get() {
        return this.$store.state.wycContent.wycContent;
      },
      set(val) {
        this.$store.state.wycContent.wycContent = val;
      }
    },
    showMsg: {
      get() {
        return this.$store.state.wycContent.showMsg;
      },
      set(val) {
        this.$store.state.wycContent.showMsg = val;
      }
    }
  },
  updated() {
    // let contentdom = document.getElementById("editorAndAdvPanel");
    // let btnWidth = contentdom.offsetWidth;
    // let contentWidth = document.documentElement.clientWidth;
    // if (btnWidth >= 820 && contentWidth < 1100) {
    //   document.getElementsByClassName(
    //     "wyc_list_btn listbutton"
    //   )[0].style.right = "10";
    // }
  },
async  created(){
      var result=await this.AGetFriendship();
           if(result.errorCode==0 && result.data.rowCount>0){

            this.dataSource=result.data.dataSource;
           }
  },
 async mounted() {
    this.contentHeight = document.documentElement.clientHeight;
    this.contentWidth = document.documentElement.clientWidth;
    // this.$nextTick(() => {
    //   this.getShowBtn();
    // });
    const that = this;
    window.onresize = function temp() {
      that.contentHeight = document.documentElement.clientHeight;
      that.contentWidth = document.documentElement.clientWidth;
      // that.$nextTick(() => {
      //   that.getShowBtn();
      // });
    };
    // this.leftShow = true;
    // this.scShow = true;

    // this.rightShow = true;
    
  },
  methods: {
        ...mapActions("api", ['AGetFriendship']),
    ...mapMutations("contents", [
      "setShowLoginDialogs",
      "setshowPrompt",
      "setshowUpgrade",
      "setShowMessageBox",
      "setShowGift"
    ]),
    openLeftMain() {
      this.leftShow = !this.leftShow;
    },
    closeShowDialogs(val) {
      this.setShowLoginDialogs(val);
    },
    closeShowPrompt(val) {
      this.setshowPrompt(val);
    },
    closeUpgrade(val) {
      this.setshowUpgrade(val);
    },
    closeShowGift(val) {
      this.setShowGift(val);
    },
    closeShowMessageBox(val) {
      this.setShowMessageBox(val);
    }
  }
};
</script>

<style lang="less" scoped>
.rContent {
  z-index: 1901;
}
.listbutton {
  padding: 5px 10px;
  position: fixed;
  right: 20px;
  top: 25%;
}
#centerEditMain {
  min-width: 640px;
  max-width: 820px;
  width: 820px;
  text-align: center;
  margin: 0 auto;
}
.open_left {
  position: fixed;
  top: 47%;
  left: 70px;
  cursor: pointer;
}
.close_left {
  position: fixed;
  top: 47%;
  left: 550px;
  cursor: pointer;
}
/deep/.el-header {
  position: fixed;
  width: 100%;
  z-index: 2000;
}
/deep/.el-main {
  padding: inherit;
  /*margin-top: 60px;*/
  /*padding-top: 60px;*/
  position: relative;
  top: 60px;
}

.links {
    padding-top: 10px;
    color: black !important;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
}
.links .link-item{
     color:black !important;
    display: inline-block;
    margin-right: 13px;
    cursor: pointer;
}
</style>
